import type { Procedure, ProcedureDetail, Place } from "./types";

export const isProcedure = (
  proc: Procedure | ProcedureDetail,
): proc is Procedure => {
  return "id" in proc && typeof proc.id === "string" && proc.id.length > 0;
};

export const isPlace = (place: Place | Omit<Place, "id">): place is Place => {
  return "id" in place && typeof place.id === "string" && place.id.length > 0;
};
